import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "@/components/auth/AuthLayout";
import { useAuth } from "@/contexts/AuthContext";

const Register = () => {
  const { register, formatApiErrorDetail } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }
    setLoading(true);
    try {
      await register(email.trim(), password, name.trim());
      toast.success("Account created. Let's set up your profile.");
      nav("/onboarding");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Sign up failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={<>Join the <span className="text-[#C6FF00]">Crew.</span></>}
      subtitle="Create Account"
      footer={
        <>
          Already a member?{" "}
          <Link to="/login" className="text-[#C6FF00] font-semibold" data-testid="register-go-login">
            Sign in
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="flex flex-col gap-4" data-testid="register-form">
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-neutral-400 font-semibold block mb-2">
            Name
          </label>
          <input
            data-testid="register-name"
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full bg-[#111] border border-white/10 rounded-md px-4 py-3 text-white placeholder:text-neutral-600 focus:outline-none focus:border-[#C6FF00] transition-colors"
            placeholder="Jordan"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-neutral-400 font-semibold block mb-2">
            Email
          </label>
          <input
            data-testid="register-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-[#111] border border-white/10 rounded-md px-4 py-3 text-white placeholder:text-neutral-600 focus:outline-none focus:border-[#C6FF00] transition-colors"
            placeholder="you@gymrat.com"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-neutral-400 font-semibold block mb-2">
            Password
          </label>
          <input
            data-testid="register-password"
            type="password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-[#111] border border-white/10 rounded-md px-4 py-3 text-white placeholder:text-neutral-600 focus:outline-none focus:border-[#C6FF00] transition-colors"
            placeholder="At least 8 characters"
          />
        </div>
        <button
          data-testid="register-submit"
          type="submit"
          disabled={loading}
          className="mt-2 bg-[#C6FF00] hover:bg-[#AEE600] text-[#0A0A0A] font-bold text-sm uppercase tracking-[0.25em] px-6 py-4 rounded-md transition-all disabled:opacity-60 hover:scale-[1.02] shadow-[0_0_20px_rgba(198,255,0,0.25)]"
        >
          {loading ? "Creating…" : "Create Account"}
        </button>
      </form>
    </AuthLayout>
  );
};

export default Register;
